module.exports = __webpack_public_path__ + "img/DSC_4361.5248a1d3.jpg";